import React from 'react';
import { QuestionRendererProps } from './QuestionRenderer';

const CheckboxGroupRenderer: React.FC<Omit<QuestionRendererProps, 'questionNumber'>> = ({
  question,
  value,
  onChange,
  error,
}) => {
  const options = question.options || [];
  const selectedValues: string[] = Array.isArray(value) ? value : [];

  const handleChange = (optionValue: string, checked: boolean) => {
    let newValues: string[];

    if (checked) {
      newValues = [...selectedValues, optionValue];
    } else {
      newValues = selectedValues.filter(v => v !== optionValue);
    }

    onChange(newValues);
  };

  return (
    <div className="space-y-3">
      {options.map((option) => {
        const isChecked = selectedValues.includes(option.value);

        return (
          <label
            key={option.value}
            className={`flex items-start p-4 border-2 rounded-lg cursor-pointer transition-all ${
              isChecked
                ? 'border-blue-500 bg-blue-50'
                : error
                ? 'border-red-200 hover:border-red-300'
                : 'border-gray-200 hover:border-gray-300'
            }`}
          >
            <input
              type="checkbox"
              value={option.value}
              checked={isChecked}
              onChange={(e) => handleChange(option.value, e.target.checked)}
              className="mt-1 h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
              aria-invalid={!!error}
            />
            <div className="ml-3 flex-1">
              <span className="block text-gray-900 font-medium">{option.label}</span>
            </div>
          </label>
        );
      })}
    </div>
  );
};

export default CheckboxGroupRenderer;
